import axiosClient from "../../axiosClient"

// The caller's own company billing gate (HR reads its own company; ADMIN may pass ?companyId=).
// Returns { billingMode, status, canCreate, graceWarning, blockReason }. Shared by the header
// indicator and the create-TruCheck dialog.
const service = async () => {
    const result = await axiosClient.get(`/company-billing-status`)
    return result.data
}

export default service
